import { IconDefinition } from '@ant-design/icons-angular';
import {
  UnorderedListOutline,
  FormOutline,
  BarChartOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  HomeOutline,
  TeamOutline,
  FileTextOutline,
  PlusOutline,
  EditOutline,
  DeleteOutline,
  EyeOutline,
  DownloadOutline,
  SearchOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  BellOutline,
  UserOutline,
  MailOutline,
  LogoutOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  ClockCircleOutline,
  WarningOutline,
  ExclamationCircleOutline,
  UploadOutline,
  LoginOutline,
  FileExcelOutline,
  InfoCircleOutline,
  ReloadOutline,
  ToolOutline,
  ContainerOutline,
  StarOutline,
  StarFill,
  DownOutline,
  UpOutline,
  EyeInvisibleOutline,
  FileAddOutline,
  FolderAddOutline,
  CopyOutline,
  PrinterOutline,
  DatabaseOutline,
  PercentageOutline,
  ExportOutline,
  LockOutline
} from '@ant-design/icons-angular/icons';

export const icons: IconDefinition[] = [
  UnorderedListOutline,
  FormOutline,
  BarChartOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  HomeOutline,
  TeamOutline,
  FileTextOutline,
  PlusOutline,
  EditOutline,
  DeleteOutline,
  EyeOutline,
  DownloadOutline,
  SearchOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  BellOutline,
  UserOutline,
  MailOutline,
  LogoutOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  ClockCircleOutline,
  WarningOutline,
  ExclamationCircleOutline,
  UploadOutline,
  LoginOutline,
  FileExcelOutline, 
  InfoCircleOutline,
  ReloadOutline,
  ToolOutline,
  ContainerOutline,
  StarOutline,
  StarFill,
  DownOutline,
  UpOutline,
  EyeInvisibleOutline,
  FileAddOutline,
  FolderAddOutline,
  CopyOutline,
  PrinterOutline,
  DatabaseOutline,
  PercentageOutline,
  ExportOutline,
  LockOutline
];